import { toastError } from '@components/Toast';

import * as actionTypes from '@store/dashboard/commercial-dashboard/action-types';

export const onSetSelectedBrand = (selected) => async (dispatch) => {
	try {
		dispatch({
			type: actionTypes.SET_SELECTED_BRANDS_SUCCESS,
			payload: selected
		});
	} catch (error) {
		dispatch({ type: actionTypes.SET_SELECTED_BRANDS_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const onSetSelectedManager = (selected) => async (dispatch) => {
	try {
		dispatch({
			type: actionTypes.SET_SELECTED_MANAGER_SUCCESS,
			payload: selected
		});
	} catch (error) {
		dispatch({ type: actionTypes.SET_SELECTED_MANAGER_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const onSetOrderSearch = (searchTerm) => async (dispatch) => {
	try {
		dispatch({
			type: actionTypes.SET_ORDER_SEARCH_INPUT_SUCCESS,
			payload: searchTerm
		});
	} catch (error) {
		dispatch({ type: actionTypes.SET_ORDER_SEARCH_INPUT_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};
